import { SourceName, SourceNameWithNamespace } from 'v2/core/entities/fields';

export const encodeSourceToString = (
  source: SourceNameWithNamespace,
): string => {
  if (source?.namespace) {
    return JSON.stringify(source);
  }
  return JSON.stringify({ name: source?.name, namespace: undefined });
};

export const decodeSourceFromString = (
  source: string,
): SourceNameWithNamespace => {
  try {
    return JSON.parse(source);
  } catch (e) {
    return {
      name: source as SourceName,
    };
  }
};
